<app-capital-container size="M" [compactTop]="true">
    <app-capital-back></app-capital-back>
    @if(isProccessStarted()) {
    <app-agile-login-stepper [steps]="steps"></app-agile-login-stepper>
    } @else {
    <app-agile-login-instructions (click)="isProccessStarted.set(true)"
        [disabled]="isAgileConnected ? !isAgileConnected() : true"></app-agile-login-instructions>
    }
</app-capital-container>